import { VaultUrl } from "./VaultUrl";

export function assertVaultUrl(url: VaultUrl | URL): asserts url is VaultUrl {
    if (!(url instanceof VaultUrl)) {
        throw new Error(`Url: ${url.toString()} does not support image transformations`);
    }
}
